// Source of truth for disability options used across all forms.
// hindi: stored for future use (e.g. localisation), never shown in UI currently.
// Keep 'other' last — it triggers a free-text input in the form component.
// To add options: append before 'other', maintain { value, label, hindi } shape.

export const DISABILITY_OPTIONS = [
  { value: 'Vision Impairment/Blindness',    label: 'Vision Impairment/Blindness',    hindi: 'अंधापन' },
  { value: 'Hearing Impaired',               label: 'Hearing Impaired',               hindi: 'हियरिंग इम्पैर्मेंट' },
  { value: 'Deaf',                           label: 'Deaf',                           hindi: 'बहरापन' },
  { value: 'Physical Disability',            label: 'Physical Disability',            hindi: 'शारीरिक विकलांगता' },
  { value: 'Mental Illness',                 label: 'Mental Illness',                 hindi: 'मानसिक बिमारी' },
  { value: 'Intellectual Disability',        label: 'Intellectual Disability',        hindi: 'बौद्धिक विकलांगता' },
  { value: 'Autism',                         label: 'Autism',                         hindi: 'ऑटिज़्म' },
  { value: 'ADHD',                           label: 'ADHD',                           hindi: 'ऐ डी एच डी' },
  { value: 'Acid Attack Survivor',           label: 'Acid Attack Survivor',           hindi: 'एसिड अटैक सर्वाइवर' },
  { value: 'Amputee',                        label: 'Amputee',                        hindi: 'ऐमप्‍युटी' },
  { value: 'Cancer',                         label: 'Cancer',                         hindi: 'कैंसर' },
  { value: 'Cerebral Palsy',                 label: 'Cerebral Palsy',                 hindi: 'सेरेब्रल पाल्सी' },
  { value: 'Chronic Illness',                label: 'Chronic Illness',                hindi: 'क्रोनिक बीमारी' },
  { value: 'Down Syndrome',                  label: 'Down Syndrome',                  hindi: 'डाउन सिंड्रोम' },
  { value: 'Dwarfism',                       label: 'Dwarfism',                       hindi: 'बौनापन' },
  { value: 'Epilepsy / Seizure Disorder',    label: 'Epilepsy / Seizure Disorder',    hindi: 'एपिलेप्सी / सीजर डिसऑर्डर' },
  { value: 'Fragile X Syndrome',             label: 'Fragile X Syndrome',             hindi: 'फ्रेजायिल एक्स सिंड्रोम' },
  { value: 'Genetic Syndrome',               label: 'Genetic Syndrome',               hindi: 'जेनेटिक सिंड्रोम' },
  { value: 'Global Developmental Delay',     label: 'Global Developmental Delay',     hindi: 'ग्लोबल डिवेलपमेंटल डीले' },
  { value: 'HIV/AIDS',                       label: 'HIV/AIDS',                       hindi: 'एचआईवी/एड्स' },
  { value: 'Learning Disability',            label: 'Learning Disability',            hindi: 'लर्निंग डिसेबिलिटी' },
  { value: 'Leprosy Cured',                  label: 'Leprosy Cured',                  hindi: 'कुष्ठ रोग मुक्त' },
  { value: 'Multiple Sclerosis',             label: 'Multiple Sclerosis',             hindi: 'मल्टीपल स्क्लेरोसिस' },
  { value: 'Muscular Dystrophy',             label: 'Muscular Dystrophy',             hindi: 'मस्क्युलर डिस्ट्रॉफी' },
  { value: 'Neurological Conditions',        label: 'Neurological Conditions',        hindi: 'न्यूरोलॉजिकल स्थितियाँ' },
  { value: 'No Disability',                  label: 'No Disability',                  hindi: 'कोई विकलांगता नहीं' },
  { value: 'Sensory Processing Disorder',    label: 'Sensory Processing Disorder',    hindi: 'सेंसरी प्रोसेसिंग डिसोर्डर' },
  { value: 'Social Anxiety',                 label: 'Social Anxiety',                 hindi: 'सामाजिक घबराहट' },
  { value: 'Speech and Language Disability', label: 'Speech and Language Disability', hindi: 'भाषण और भाषा विकलांगता' },
  { value: 'Spina Bifida',                   label: 'Spina Bifida',                   hindi: 'स्पाइना बिफ़ीडा' },
  { value: 'Spinal Cord Injury',             label: 'Spinal Cord Injury',             hindi: 'स्पाइनल कॉर्ड इंजरी' },
  { value: 'Tourettes Syndrome',             label: 'Tourettes Syndrome',             hindi: 'टुर्रेट्स सिंड्रोम' },
  { value: 'Traumatic Brain Injury',         label: 'Traumatic Brain Injury',         hindi: 'ट्रोमैटिक ब्रेन इंजुरी' },
  { value: 'Undisclosed',                    label: 'Undisclosed',                    hindi: 'खुलासा नहीं' },
  { value: 'other',                          label: 'Other (please specify)',         hindi: 'अन्य' },
];

// Shared react-select style overrides — matches App.css design tokens.
// Import into any component that renders a disability dropdown.
export const disabilitySelectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '50px',
    fontSize: '15px',
    borderRadius: '12px',
    border: `2px solid ${state.isFocused ? '#E57542' : '#E2E8F0'}`,
    boxShadow: state.isFocused ? '0 0 0 3px rgba(229, 117, 66, 0.1)' : 'none',
    '&:hover': { borderColor: state.isFocused ? '#E57542' : '#CBD5E1' },
    fontFamily: 'inherit',
    transition: 'all 0.2s ease',
    cursor: 'pointer',
  }),
  option: (base, state) => ({
    ...base,
    fontSize: '15px',
    fontFamily: 'inherit',
    backgroundColor: state.isSelected ? '#E57542' : state.isFocused ? '#FEF3E9' : 'white',
    color: state.isSelected ? 'white' : '#2D3748',
    cursor: 'pointer',
  }),
  menu: (base) => ({
    ...base,
    borderRadius: '12px',
    border: '2px solid #E2E8F0',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    overflow: 'hidden',
  }),
  placeholder: (base) => ({ ...base, color: '#94A3B8', fontSize: '15px' }),
  singleValue: (base) => ({ ...base, color: '#2D3748' }),
};